import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import PenTool from '../assets/icons/feather/Pen tool.svg?react';

export function PenToolIcon(props: SvgIconProps) {
  return <SvgIcon component={PenTool} inheritViewBox {...props} />;
}
